import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
// tslint:disable-next-line:max-line-length
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
  TipoConfirmacionModalType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { Router } from "@angular/router";
import { FonturService } from "./fontur.service";
// tslint:disable-next-line:max-line-length
import { ModalConfirmacionSolicitudComponent } from "src/app/components/core/layouts/modal-confirmacion-solicitud/modal-confirmacion-solicitud.component";
import { CompletaInformacionService } from "../completa-informacion/completa-informacion.service";
import { PagoParafiscalService } from "../pago-parafiscal/pago-parafiscal.service";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { Subscription, forkJoin } from "rxjs";
import { AuthService } from "src/app/shared/services/auth.service";
import { TipoRnt } from "src/app/shared/enumeraciones/tipo-rnt.enum";
import { AyudasService } from "src/app/components/contenido/containers/ayudas/ayudas.service";
import { isNull } from "util";
import { ModalEncuestaRenovacionComponent } from "src/app/components/core/layouts/modal-encuesta-renovacion/modal-encuesta-renovacion.component";
import { TipoSolicitud } from "src/app/shared/enumeraciones/tipo-solicitud.enum";
import { EstadosRnt } from "src/app/shared/enumeraciones/estados-rnt.enum";
import { EstablecimientoComercioService } from "../../establecimiento-comercio/establecimiento-comercio.service";
import { map, take } from "rxjs/operators";
import { SubcategoriaService } from "../../../administrador/configuracion/subcategoria/subcategoria.service";
import { ModalValidarActividadesEconomicasComponent } from "src/app/components/core/layouts/modal-validar-actividades-economicas/modal-validar-actividades-economicas.component";
import { BaseServiceService } from "src/app/shared/services/base-service.service";
import { ActividadEconomicaEntry } from "src/app/shared/entrys/actividad-economica.entry";
import { SolicitudService } from "../../solicitudes/solicitud.service";
import { ModalCorreoMensajeComponent } from "src/app/components/core/layouts/modal-correo-mensaje/modal-correo-mensaje.component";
import { ResultadoValidacionModel } from "src/app/shared/models/resultado-validacion.model";

@Component({
  selector: "app-fontur",
  templateUrl: "./fontur.component.html",
  styleUrls: ["./fontur.component.scss"],
})
export class FonturComponent implements OnInit {
  @Output()
  pasoActual: EventEmitter<number> = new EventEmitter();

  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  rnt: RNTPrestadorEntry;
  subscription: Subscription;
  validacionFontur = -1;
  mensajeFontur: string;
  datosFontur: any;
  terminarSolicitud = false;
  btnString = "Salir";

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private fonturService: FonturService,
    private completaInformacionService: CompletaInformacionService,
    private pagoParafiscalService: PagoParafiscalService,
    private dataSharedService: DataSharedService,
    private authService: AuthService,
    public ayudaService: AyudasService,
    private establecimientoComercioService: EstablecimientoComercioService,
    private subCategoriaService: SubcategoriaService,
    private baseService: BaseServiceService,
    private solicitudService: SolicitudService
  ) {
    this.subscription = this.dataSharedService.data$.subscribe((dataShared) => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
      this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
    });
  }

  ngOnInit() {
    if (
      this.rnt.aplica_pago_parafiscales &&
      this.rnt.aplica_pago_parafiscales === true
    ) {
      this.pasoActual.emit(6);
    } else {
      this.pasoActual.emit(5);
    }
    this.rnt.paso = 6;
    this.fonturService
      .validarFontur({
        ...this.rnt,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          if (isNull(resultado.data.supera_validacion_fontur)) {
            this.validacionFontur = 1;
          } else if (
            resultado.data.supera_validacion_fontur &&
            resultado.data.code === 3
          ) {
            this.validacionFontur = 3;
          } else if (resultado.data.supera_validacion_fontur) {
            this.validacionFontur = 0;
          } else {
            this.validacionFontur = 2;
          }

          this.mensajeFontur = resultado.data.respuesta_validacion_fontur;
          this.datosFontur = resultado.data;
          this.validarFontur();
        }
      });
  }

  goPaso(): void {
    if (this.terminarSolicitud) {
      const modalRef = this.modalService.open(
        ModalConfirmarRespuestaComponent,
        { centered: true }
      );
      const confirmarRespuesta = {} as ConfirmarRespuestaModel;
      confirmarRespuesta.tipoConfirmacionModalType =
        TipoConfirmacionModalType.Confirmacion;
      confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
      confirmarRespuesta.message =
        "¿Está seguro que desea finalizar la solicitud?";
      modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
      modalRef.result.then(_ => {
        this.finalizar();
      });
    } else {
      const modalRef = this.modalService.open(
        ModalConfirmarRespuestaComponent,
        { centered: true }
      );
      const confirmarRespuesta = {} as ConfirmarRespuestaModel;
      confirmarRespuesta.tipoConfirmacionModalType =
        TipoConfirmacionModalType.Confirmacion;
      confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
      confirmarRespuesta.message =
        "¿Está seguro que desea salir de la solicitud?";
      modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
      modalRef.result.then((resultadoModal) => {
        this.router.navigate(["/mis-establecimientos"]);
      });
    }
  }

  validarFontur() {
    this.btnString = "Salir";

    if (this.validacionFontur === 0) {
      this.terminarSolicitud = true;
      this.btnString = "Finalizar";
    } else if (this.validacionFontur === 1) {
      this.terminarSolicitud = true;
      this.btnString = "Finalizar";
    } else if (this.validacionFontur === 3) {
      this.terminarSolicitud = true;
      this.btnString = "Finalizar";
    } else {
      this.terminarSolicitud = false;
    }
  }
  tieneEncuestaOpcional(): void {
    if (!(this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion) &&
      !(this.datoSolicitudSharedModel.data.estado_rnt_id ===
        EstadosRnt.SuspendidoPorNoRenovar &&
        this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Reactivacion)) {
      this.router.navigate(['/mis-establecimientos']);
    } else {
      this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
        data: { ...this.rnt },
        tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
        tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
        estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud
      });
      this.onModalEncuesta();
    }
  }
  onModalEncuesta(): void {
    this.completaInformacionService
      .getParametro({
        parametro_id: "MENSAJE_MODAL_ENCUESTA_DE_TURISMO",
        agrupacion: "TRATAMIENTO_DATOS",
        auxiliar: "1",
      }).subscribe(response => {
        if (response.result) {
          const modalEncuestaRenovacionComponent = this.modalService.open(
            ModalEncuestaRenovacionComponent,
            { centered: true, backdrop: "static", size: "md" }
          );
          modalEncuestaRenovacionComponent.componentInstance.mensaje = response.data;
          modalEncuestaRenovacionComponent.result
            .then(result => {
              this.router.navigate(['/solicitud/encuesta']);
            }).catch((_) => {
              this.router.navigate(['/mis-establecimientos']);
            });
        }
      });
  }
  onRegresarPaso(): void {
    const rnt: RNTPrestadorEntry = {
      ...this.rnt,
      tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
    };
    this.completaInformacionService.update(rnt).subscribe((resultado) => {
      if (resultado.result) {
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: { ...this.rnt },
          tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
          tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
          estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
        });
        if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles) {
          this.router.navigate(["solicitud/completa-informacion-inmueble"]);
        } else {
          if (this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.Guia) {
            this.router.navigate(["solicitud/completa-informacion"]);
          } else {
            this.router.navigate(["solicitud/completa-informacion-guia"]);
          }
        }
      }
    });
  }

  // private mostrarErrorActividadEconomicaInvalida() {
  //   let $mensajeError = this.completaInformacionService
  //     .getParametro({ parametro_id: "ADVERTENCIA_ACTIVIDAD_ECONOMICA_NO_CORRESPONDE_SUBCATEGORIA_PRESTADOR", agrupacion: "VALIDACIONES", auxiliar: "1", })
  //     .pipe(map(resultado => resultado.result ? resultado.data : ""));

  //   let $descripcionCorrespondenciaSubCategoria = this.subCategoriaService.getDescripcionCorrespondenciaCiiu(this.rnt.sub_categoria_id)
  //     .pipe(map(resultado => resultado.data));

  //   let $actividadesEconomicas = this.baseService.getActividadesEconomicasPrestador(this.authService.getUserNameToken())
  //     .pipe(map(resultado => resultado.control.code == 200 ? resultado.data as ActividadEconomicaEntry[] : []));

  //   forkJoin([$mensajeError, $descripcionCorrespondenciaSubCategoria, $actividadesEconomicas]).pipe(
  //     take(1)
  //   ).subscribe(([mensajeError, descripcionCorrespondenciaSubCategoria, actividadesEconomicas]) => {
  //     const modal = this.modalService.open(ModalValidarActividadesEconomicasComponent, { centered: true, backdrop: "static", size: "lg" });
  //     modal.componentInstance.mensaje = mensajeError;
  //     modal.componentInstance.descripcionCorrespondenciaSubCategoria = descripcionCorrespondenciaSubCategoria;
  //     modal.componentInstance.actividadesEconomicas = actividadesEconomicas;
  //   });
  // }

  private mostrarNotificacionEnviada(notificacion: string) {
    const modalRef = this.modalService.open(ModalCorreoMensajeComponent,
      { centered: true, size: 'lg', backdropClass: 'light-blue-backdrop' });
    const entry = {
      contenido_mensaje: notificacion
    };
    modalRef.componentInstance.notificacion = entry;
  }

  private finalizar() {

    let camaraAc = localStorage.getItem("keyCamaraID") !== null ? localStorage.getItem("keyCamaraID") : "";
    let MatAc = localStorage.getItem("keyMatricula") !== null ? localStorage.getItem("keyMatricula") : "";

    this.rnt.codigo_camaraestacti = camaraAc;
    this.rnt.matricula_estacti = MatAc;

    this.pagoParafiscalService
      .delete(this.rnt)
      .subscribe((resultadoMigra) => {
        if (resultadoMigra.result) {
          this.completaInformacionService
            .sendNotificar(this.rnt)
            .subscribe((resultadoNotifica) => {
              if (resultadoNotifica.result) {
                const modalFinalizar = this.modalService.open(
                  ModalConfirmacionSolicitudComponent,
                  { centered: true }
                );
                modalFinalizar.componentInstance.mensaje =
                  resultadoNotifica.data;
                modalFinalizar.result
                  .then(() => {
                    this.tieneEncuestaOpcional();
                  })
                  .catch(() => {
                    this.tieneEncuestaOpcional();
                  });
              } else if (resultadoNotifica.control?.code == 4114) {
                try {
                  const resultadoValidacion = JSON.parse(resultadoNotifica.data) as ResultadoValidacionModel;
                  // if (resultadoValidacion.actividad_economica_valida == false)
                  //   this.mostrarErrorActividadEconomicaInvalida();
                  if (resultadoValidacion.notificacion)
                    this.mostrarNotificacionEnviada(resultadoValidacion.notificacion);
                    this.reset_LocalStorage();
                } catch {
                }
              }
            });
        }
      });
  }

  reset_LocalStorage(){
		localStorage.removeItem("keyCamaraID");
		localStorage.removeItem("keyMatricula");
	  }
}
